<div class="card" (click)="cardClicked()">
    <div class="card-content">
        <div class="card-icon">
            <mat-icon svgIcon="medicine_2"></mat-icon>
        </div>
        <div class="card-body">
            <span class="card-title text-capitalize font-weight-bold dark-grey">{{stock.name}} ({{stock.quantity}} |
                {{stock.unitOfMeasure}})</span>
            <h6 class="card-subtitle mb-2 text-muted text-uppercase">SKU {{stock.barcode}}</h6>
        </div>
    </div>
</div>